import {
  BookOpen,
  BookUser,
  BrainCircuit,
  CalendarDays,
  Presentation,
  Quote,
  Star,
  Tickets,
  User,
  Users,
} from "lucide-react"

import type { WorkspaceDefinition } from "@/components/workspace/definition"
import {
  editEducatorsTeacherProfile,
  educatorsTeacherClasses,
  educatorsTeacherFeedback,
  educatorsTeacherReliefBookings,
  educatorsTeacherReliefListings,
  educatorsTeacherSpecialities,
  educatorsTeacherTeams,
  educatorsTeacherTimetable,
  educatorsTeacherWorkspace,
} from "@/routes"

// A teacher's workspace: its home page, its destinations in the order the
// workspace page and the role menu list them, and the role's mark in the
// header. The owner id is the teacher's.
export const teacherWorkspace: WorkspaceDefinition = {
  ownerType: "teacher",
  root: (teacherId) => educatorsTeacherWorkspace({ teacherId }).url,
  destinations: [
    {
      key: "profile",
      href: (teacherId) => editEducatorsTeacherProfile({ teacherId }).url,
      titleKey: "workspace:links.profile",
      descriptionKey: "workspace:links.profile_description",
      icon: User,
    },
    {
      key: "specialities",
      href: (teacherId) => educatorsTeacherSpecialities({ teacherId }).url,
      titleKey: "workspace:links.specialities",
      descriptionKey: "workspace:links.specialities_description",
      icon: Star,
    },
    {
      key: "classes",
      href: (teacherId) => educatorsTeacherClasses({ teacherId }).url,
      titleKey: "workspace:links.classes",
      descriptionKey: "workspace:links.classes_description",
      icon: BookOpen,
    },
    {
      key: "timetable",
      href: (teacherId) => educatorsTeacherTimetable({ teacherId }).url,
      titleKey: "workspace:links.timetable",
      descriptionKey: "workspace:links.timetable_description",
      icon: CalendarDays,
    },
    {
      key: "teams",
      href: (teacherId) => educatorsTeacherTeams({ teacherId }).url,
      titleKey: "workspace:links.teams",
      descriptionKey: "workspace:links.teams_description",
      icon: Users,
    },
    {
      key: "measurement_and_feedback",
      href: (teacherId) => educatorsTeacherFeedback({ teacherId }).url,
      titleKey: "workspace:links.measurement_and_feedback",
      descriptionKey: "workspace:links.measurement_and_feedback_description",
      icon: Quote,
    },
    {
      key: "learning_enhancement_technologies",
      href: null,
      titleKey: "workspace:links.learning_enhancement_technologies",
      descriptionKey:
        "workspace:links.learning_enhancement_technologies_description",
      icon: BrainCircuit,
    },
    {
      key: "relief_listings",
      href: (teacherId) => educatorsTeacherReliefListings({ teacherId }).url,
      titleKey: "workspace:links.relief_listings",
      descriptionKey: "workspace:links.relief_listings_description",
      icon: BookUser,
    },
    {
      key: "relief_bookings",
      href: (teacherId) => educatorsTeacherReliefBookings({ teacherId }).url,
      titleKey: "workspace:links.relief_bookings",
      descriptionKey: "workspace:links.relief_bookings_description",
      icon: Tickets,
    },
  ],
  namespaces: ["workspace"],
  icon: Presentation,
  tint: "bg-brand-light-wise-green",
}
